import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=261f33c2&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=ts&"
export * from "./Brand.vue?vue&type=script&lang=ts&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=261f33c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f33c2",
  null
  
)

export default component.exports